/* eslint-disable import/no-anonymous-default-export */
import { lazy } from "react";
import Loadable from "../../components/layout/Loadable";

const Product = Loadable(lazy(() => import("../../pages/admin/product")));
const AddProduct = Loadable(
  lazy(() => import("../../pages/admin/product/AddProduct"))
);
const EditProduct = Loadable(
  lazy(() => import("../../pages/admin/product/EditProduct"))
);


const ProductSpecification = Loadable(
  lazy(() => import("../../pages/admin/product/ProductSpecification"))
);

const ProductRatings = Loadable(
  lazy(() => import("../../pages/admin/product/ProductRatings"))
);

const ReorderProductSpecification = Loadable(
  lazy(() => import("../../pages/admin/product/ProductSpecificationReorder"))
);


const ProductFaq = Loadable(
  lazy(() => import("../../pages/admin/product/ProductFaq"))
);
const ProductImageList = Loadable(
  lazy(() => import("../../pages/admin/product/ProductImageList"))
);



// routes of category types
const CategoryTypes = Loadable(
  lazy(() => import("../../pages/admin/category/CategoryTypes"))
);
const CategoryProducts = Loadable(
  lazy(() => import("../../pages/admin/category/category-products/CategoryProducts"))
);
const AddCategoryTypes = Loadable(
  lazy(() => import("../../pages/admin/category/AddCategoryTypes"))
);
const EditCategoryTypes = Loadable(
  lazy(() => import("../../pages/admin/category/EditCategoryTypes"))
);

// routes of category
const Category = Loadable(
  lazy(() => import("../../pages/admin/category/Category"))
);
const AddCategory = Loadable(
  lazy(() => import("../../pages/admin/category/AddCategory"))
);
const ReorderCategory = Loadable(
  lazy(() => import("../../pages/admin/category/CategoryReorder"))
);
const EditCategory = Loadable(
  lazy(() => import("../../pages/admin/category/EditCategory"))
);
const CategorySpecification = Loadable(
  lazy(() => import("../../pages/admin/category/CategorySpecification"))
);

const ReorderCategorySpecification = Loadable(
  lazy(() => import("../../pages/admin/category/CategorySpecificationReorder"))
); const CategoryFaq = Loadable(
  lazy(() => import("../../pages/admin/category/CategoryFaq"))
);

const Cities = Loadable(
  lazy(() => import("../../pages/admin/cities/index"))
);
const ReorderCities = Loadable(
  lazy(() => import("../../pages/admin/cities/ReorderCities"))
);
const AddCities = Loadable(
  lazy(() => import("../../pages/admin/cities/AddCities"))
);

const EditCities = Loadable(
  lazy(() => import("../../pages/admin/cities/EditCities"))
);
const CitiesFaq = Loadable(
  lazy(() => import("../../pages/admin/cities/CityFaq"))
);

const ReorderFaqCity = Loadable(
  lazy(() => import("../../pages/admin/cities/ReorderFaqCity"))
);

const CitiesSpecification = Loadable(
  lazy(() => import("../../pages/admin/cities/CitiesSpecification"))
);

const ReorderCitiesSpecification = Loadable(
  lazy(() => import("../../pages/admin/cities/CitiesSpecificationReorder"))
);

const Applications = Loadable(
  lazy(() => import("../../pages/admin/applications"))
);
const AddApplications = Loadable(
  lazy(() => import("../../pages/admin/applications/AddApplications"))
);

const EditApplications = Loadable(
  lazy(() => import("../../pages/admin/applications/EditApplications"))
);


const ApplicationFaq = Loadable(
  lazy(() => import("../../pages/admin/applications/ApplicationFaq"))
);
const ReorderApplications = Loadable(
  lazy(() => import("../../pages/admin/applications/ReorderApplications"))
);

const ProductAddList = Loadable(
  lazy(() => import("../../components/admin/applications/ProductAddList"))
);

const SubApplications = Loadable(lazy(() => import("../../pages/admin/subApplications")));
const AddSubApplications = Loadable(lazy(() => import("../../pages/admin/subApplications/AddSubApplications")));
const EditSubApplications = Loadable(lazy(() => import("../../pages/admin/subApplications/EditSubApplication")));

//Application
const Standards = Loadable(
  lazy(() => import("../../pages/admin/application/standards"))
);
const AddStandard = Loadable(
  lazy(() => import("../../pages/admin/application/standards/AddStandard"))
);
const EditStandard = Loadable(
  lazy(() => import("../../pages/admin/application/standards/EditStandard"))
);

const Industries = Loadable(
  lazy(() => import("../../pages/admin/application/industries"))
);
const AddIndustries = Loadable(
  lazy(() => import("../../pages/admin/application/industries/AddIndustries"))
);
const EditIndustries = Loadable(
  lazy(() => import("../../pages/admin/application/industries/EditIndustries"))
);

const Materials = Loadable(
  lazy(() => import("../../pages/admin/application/materials"))
);
const AddMaterials = Loadable(
  lazy(() => import("../../pages/admin/application/materials/AddMaterial"))
);
const EditMaterials = Loadable(
  lazy(() => import("../../pages/admin/application/materials/EditMaterial"))
);

const Tests = Loadable(
  lazy(() => import("../../pages/admin/application/tests"))
);
const AddTest = Loadable(
  lazy(() => import("../../pages/admin/application/tests/AddTest"))
);
const EditTest = Loadable(
  lazy(() => import("../../pages/admin/application/tests/EditTest"))
);


//Knowledge Base
const News = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/news"))
);
const AddNews = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/news/AddNews"))
);
const EditNews = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/news/EditNews"))
);

const BlogCategories = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/blogCategories/index"))
);

const Article = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/articles"))
);
const AddArticle = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/articles/AddArticle"))
);
const EditArticle = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/articles/EditArticle"))
);

const Blog = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/blogs"))
);
const AddBlog = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/blogs/AddBlog"))
);
const EditBlog = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/blogs/EditBlog"))
);

const Glossary = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/glossary"))
);
const FAQ = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/faqs"))
);
const VideoGallery = Loadable(
  lazy(() => import("../../pages/admin/knowledgeBase/videoGallery"))
);

//exhibition
const CompletedExhibiton = Loadable(
  lazy(() => import("../../pages/admin/exhibition/CompletedExhibition"))
);
const UpcomingExhibition = Loadable(
  lazy(() => import("../../pages/admin/exhibition/upcomingExhibition"))
);
const AddExhibition = Loadable(
  lazy(() =>
    import("../../pages/admin/exhibition/upcomingExhibition/AddExhibition")
  )
);
const EditExhibition = Loadable(
  lazy(() =>
    import("../../pages/admin/exhibition/upcomingExhibition/EditExhibition")
  )
);

//clients
const Clients = Loadable(
  lazy(() =>
    import("../../pages/admin/clients")
  )
);
const ReorderClients = Loadable(
  lazy(() =>
    import("../../pages/admin/clients/ReorderClients")
  )
);
const ProductCategoryReorder = Loadable(
  lazy(() =>
    import("../../pages/admin/category/category-products/ProductCategoryReorder")
  )
);

const Testimonial = Loadable(
  lazy(() =>
    import("../../pages/admin/clients/testimonialas")
  )
);
const AddTestimonial = Loadable(
  lazy(() =>
    import("../../pages/admin/clients/testimonialas/AddTestimonial")
  )
);
const EditTestimonial = Loadable(
  lazy(() =>
    import("../../pages/admin/clients/testimonialas/EditTestimonial")
  )
);

//Knowledge Base -END

//CMS
const Sections = Loadable(lazy(() => import("../../pages/admin/cms/sections")));

const InformationalPage = Loadable(lazy(() => import("../../pages/admin/cms/informationalPages")));
const AddInformationalPage = Loadable(lazy(() => import("../../pages/admin/cms/informationalPages/AddInformationalPages")));
const EditInformationalPage = Loadable(lazy(() => import("../../pages/admin/cms/informationalPages/EditInformationalPage")));

const UploadCatalogue = Loadable(lazy(() => import("../../pages/admin/cms/uploadCatalogue")));

const DynamicPage = Loadable(lazy(() => import("../../pages/admin/cms/dynamicPages")));
const AddDynamicPage = Loadable(lazy(() => import("../../pages/admin/cms/dynamicPages/AddDynamicPage")));
const EditDynamicPage = Loadable(lazy(() => import("../../pages/admin/cms/dynamicPages/EditDynamicPage")));

//CTA
const CTA = Loadable(lazy(() => import("../../pages/admin/cta")));
const AddCTA = Loadable(lazy(() => import("../../pages/admin/cta/AddCta")));
const EditCTA = Loadable(lazy(() => import("../../pages/admin/cta/EditCta")));

//Testimonial Pages
const TestimonialPages = Loadable(lazy(() => import("../../pages/admin/testimonialPages")));

//Icons
const Icons = Loadable(lazy(() => import("../../pages/admin/icons")));

//Enquiries Pages
const Enquiries = Loadable(lazy(() => import("../../pages/admin/enquiries")));



export default [
  {
    path: "products",
    children: [
      {
        path: "",
        element: <Product />,
      },
      {
        path: "add",
        element: <AddProduct />,
      },
      {
        path: "edit/:ProductID",
        element: <EditProduct />,
      },
      {
        path: "specification/:ProductID",
        element: <ProductSpecification />,
      },
      {
        path: "specification/:ProductID/reorder",
        element: <ReorderProductSpecification />,
      },
      {
        path: "reviews/:ProductID",
        element: <ProductRatings />,
      },
      {
        path: "faq/:ProductID",
        element: <ProductFaq />,
      },
      {
        path: "images/:ProductID",
        element: <ProductImageList />,
      },
    ],
  },
  {
    path: "category-types",
    children: [
      {
        path: "",
        element: <CategoryTypes />,
      },
      {
        path: "add",
        element: <AddCategoryTypes />,
      },
      {
        path: "edit/:CategoryTypeID",
        element: <EditCategoryTypes />,
      },
      {
        path: "category-products/:CategoryID",
        element: <CategoryProducts />,
      },
      {
        path: "category-products",
        children: [
          {
            path: ":CategoryID",
            children: [
              {
                path: "reorder",
                element: <ProductCategoryReorder />,
              },
            ],
          },
        ],
      },
      {
        path: "category",
        children: [
          {
            path: ":CategoryTypeID",
            children: [
              { path: "", element: <Category /> },
              {
                path: "add",
                element: <AddCategory />,
              },
              {
                path: "reorder",
                element: <ReorderCategory />,
              },
              {
                path: "edit/:CategoryID",
                element: <EditCategory />,
              },
              {
                path: "specification/:CategoryID",
                element: <CategorySpecification />,
              },
              {
                path: "specification/:CategoryID/reorder",
                element: <ReorderCategorySpecification />,
              },
              {
                path: "faq/:CategoryID",
                element: <CategoryFaq />,
              },

            ],
          },
        ],
      },
    ],
  },
  // 333


  {
    path: "applications",
    children: [
      {
        path: "",
        element: <Applications />,
      },
      {
        path: "add",
        element: <AddApplications />,
      },
      {
        path: "reorder",
        element: <ReorderApplications />,
      },
      {
        path: "edit/:ApplicationID",
        element: <EditApplications />,
      },
      {
        path: "add-product/:ApplicationID",
        element: <ProductAddList />,
      },
      {
        path: "faq/:ApplicationID",
        element: <ApplicationFaq />,
      },
    ],
  },
  {
    path: "cities",
    children: [
      {
        path: "",
        element: <Cities />,
      },
      {
        path: "add",
        element: <AddCities />,
      },
      {
        path: "edit/:CityID",
        element: <EditCities />,
      },
      {
        path: "reorder",
        element: <ReorderCities />,
      },

      {
        path: "faq/:CityID",
        element: <CitiesFaq />,
      },

      {
        path: "faq/:CityID/reorder",
        element: <ReorderFaqCity />,
      },
      {
        path: "specification/:CityID",
        element: <CitiesSpecification />,
      },
      {
        path: "specification/:CityID/reorder",
        element: <ReorderCitiesSpecification />,
      },
    ],
  },
  {
    path: "sub-applications",
    children: [
      {
        path: "",
        element: <SubApplications />,
      },
      {
        path: "add",
        element: <AddSubApplications />,
      },
      {
        path: "edit/:SubID",
        element: <EditSubApplications />
      }
    ],
  },
  {
    path: "enquiries",
    element: <Enquiries />,
  },
  {
    path: "application",
    children: [
      {
        path: "standards",
        children: [
          {
            path: "",
            element: <Standards />,
          },
          {
            path: "add",
            element: <AddStandard />,
          },
          {
            path: "edit/:StandardID",
            element: <EditStandard />,
          },
        ],
      },
      {
        path: "industries",
        children: [
          {
            path: "",
            element: <Industries />,
          },
          {
            path: "add",
            element: <AddIndustries />,
          },
          {
            path: "edit/:IndustryID",
            element: <EditIndustries />,
          },
        ],
      },
      {
        path: "materials",
        children: [
          {
            path: "",
            element: <Materials />,
          },
          {
            path: "add",
            element: <AddMaterials />,
          },
          {
            path: "edit/:MaterialID",
            element: <EditMaterials />,
          },
        ],
      },
      {
        path: "tests",
        children: [
          {
            path: "",
            element: <Tests />,
          },
          {
            path: "add",
            element: <AddTest />,
          },
          {
            path: "edit/:TestID",
            element: <EditTest />,
          },
        ],
      },
    ],
  },
  {
    path: "knowledge-base",
    children: [
      {
        path: "news",
        children: [
          {
            path: "",
            element: <News />,
          },
          {
            path: "add",
            element: <AddNews />,
          },
          {
            path: "edit/:NewsID",
            element: <EditNews />,
          },
        ],
      },
      {
        path: "articles",
        children: [
          {
            path: "",
            element: <Article />,
          },
          {
            path: "add",
            element: <AddArticle />,
          },
          {
            path: "edit/:ArticleID",
            element: <EditArticle />,
          },
        ],
      },
      {
        path: "blogs",
        children: [
          {
            path: "",
            element: <Blog />,
          },
          {
            path: "add",
            element: <AddBlog />,
          },
          {
            path: "edit/:BlogID",
            element: <EditBlog />,
          },
        ],
      },
      {
        path: "blogs-categories",
        element: <BlogCategories />,
      },
      {
        path: "glossary",
        element: <Glossary />,
      },
      {
        path: "faq",
        element: <FAQ />,
      },
      {
        path: "video-gallery",
        element: <VideoGallery />,
      },
    ],
  },
  {
    path: "exhibitions",
    children: [
      {
        path: "upcoming-exhibitions",
        children: [
          {
            path: "",
            element: <UpcomingExhibition />,
          },
          {
            path: "add",
            element: <AddExhibition />,
          },
          {
            path: "edit/:ExhibitionID",
            element: <EditExhibition />,
          },
        ],
      },
      {
        path: "completed-exhibitions",
        children: [
          {
            path: "",
            element: <CompletedExhibiton />,
          },
        ],
      },
    ],
  },
  {
    path: "clients",
    children: [
      {
        path: "",
        element: <Clients />
      },
      {
        path: "reorder",
        element: <ReorderClients />
      },
      {
        path: "testimonials",
        children: [
          {
            path: "",
            element: <Testimonial />,
          },
          {
            path: "add",
            element: <AddTestimonial />,
          },
          {
            path: "edit/:TestinomialID",
            element: <EditTestimonial />,
          },
        ],
      },
    ],
  },
  {
    path: "cms",
    children: [
      {
        path: "sections",
        element: <Sections />,
      },
      {
        path: "informational-pages",
        children: [
          {
            path: "",
            element: <InformationalPage />,
          },
          {
            path: "add",
            element: <AddInformationalPage />,
          },
          {
            path: "edit/:StaticPageID",
            element: <EditInformationalPage />,
          },
        ],
      },
      {
        path: "upload-catalogue",
        element: <UploadCatalogue />,
      },
      {
        path: "dynamic-pages",
        children: [
          {
            path: "",
            element: <DynamicPage />,
          },
          {
            path: "add",
            element: <AddDynamicPage />,
          },
          {
            path: "edit/:DynPageID",
            element: <EditDynamicPage />,
          },
        ],
      },
    ],
  },
  {
    path: "cta",
    children: [
      {
        path: "",
        element: <CTA />,
      },
      {
        path: "add",
        element: <AddCTA />,
      },
      {
        path: "edit/:CTAID",
        element: <EditCTA />,
      },
    ],
  },
  {
    path: "testimonials-pages",
    element: <TestimonialPages />
  },
    {
    path: "icons",
    element: <Icons />
  },
];
